<template>
  <div class="engineering-reports">
    <h2>{{ quoteNumber }}</h2>
    <template v-if="loading">
      <p>Loading...</p>
    </template>
    <template v-else-if="hasReports">
      <ul class="engineering-reports-list">
        <li v-for="report in reports" :key="report.slug">
          <router-link 
            :to="{ 
              name: 'Engineering Report', 
              params: {
                slug: report.slug, 
                quoteNumber
              }
            }">{{ report.title }}</router-link>
        </li>
      </ul>
      <file-download-link :src="spreadsheetDownloadURL"/>
    </template>
    <template v-else>
      <p>No reports available for this survey.</p>
    </template>
  </div>
</template>
<script>
import FileDownloadLink from '../../components/FileDownloadLink.vue';

export default {
  props: {
    quoteNumber: String
  },
  components: { 
    FileDownloadLink
  },
  data() {
    return {
      apiURL: '/api/engineering-reports/',
      loading: false,
      reports: []
    }
  },
  computed: {
    hasReports() {
      return this.reports && this.reports.length;
    },
    spreadsheetDownloadURL() {
      if(!this.quoteNumber) {
        return '';
      }

      return this.apiURL + this.quoteNumber + '/excel';
    }
  },
  methods: {
    getReports() {
      if(!this.quoteNumber) {
        return;
      }

      const url = this.apiURL + this.quoteNumber;

      this.loading = true;

      this.$http
        .get(url)
        .then((response) => {
          this.reports = response.data;
        })
        .catch(error => {
          alert("There was a problem loading report data. Please refresh the window and try again.");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getReports();
  }
}

</script>
<style lang="scss">
  .engineering-reports {
    .engineering-reports-list {
      a {
        display: inline-block;
        margin-bottom: 4px;
        color: currentColor;
        font-size: 11pt;

        &:focus,
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>